var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E6E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10C16.2804 10 10 16.2804 10 24C10 31.7196 16.2804 38 24 38C31.7196 38 38 31.7196 38 24C38 16.2804 31.7196 10 24 10ZM24 35.4545C17.684 35.4545 12.5455 30.316 12.5455 24C12.5455 17.684 17.684 12.5455 24 12.5455C30.316 12.5455 35.4545 17.684 35.4545 24C35.4545 30.316 30.316 35.4545 24 35.4545Z",
    fill: "#9DA0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5764 31.0071C22.4622 29.1215 25.5304 29.1214 27.4161 31.0071C27.9131 31.5041 28.719 31.5041 29.216 31.0071C29.7131 30.51 29.7131 29.7042 29.216 29.2072C27.7767 27.7679 25.8869 27.0485 23.9962 27.0485C22.1061 27.0485 20.2154 27.7682 18.7764 29.2072C18.2794 29.7041 18.2794 30.51 18.7764 31.0071C19.2735 31.5042 20.0794 31.5041 20.5764 31.0071Z",
    fill: "#9DA0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7737 22.4875C20.0902 22.1719 20.2709 21.7341 20.2709 21.2878C20.2709 20.8415 20.0902 20.4037 19.7737 20.088C19.458 19.7724 19.0202 19.5908 18.5739 19.5908C18.1267 19.5908 17.6898 19.7724 17.3741 20.088C17.0577 20.4037 16.877 20.8415 16.877 21.2878C16.877 21.7341 17.0577 22.1719 17.3741 22.4875C17.6898 22.804 18.1276 22.9848 18.5739 22.9848C19.0202 22.9848 19.458 22.804 19.7737 22.4875Z",
    fill: "#9DA0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4294 19.5908C28.9831 19.5908 28.5453 19.7724 28.2295 20.088C27.914 20.4037 27.7324 20.8406 27.7324 21.2878C27.7324 21.7349 27.914 22.1719 28.2295 22.4875C28.5453 22.804 28.9831 22.9848 29.4294 22.9848C29.8757 22.9848 30.3135 22.804 30.6291 22.4875C30.9448 22.1719 31.1264 21.7349 31.1264 21.2878C31.1264 20.8415 30.9447 20.4037 30.6291 20.088C30.3135 19.7724 29.8757 19.5908 29.4294 19.5908Z",
    fill: "#9DA0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown);
export default __webpack_public_path__ + "static/media/frown.e3003e59.svg";
export { ForwardRef as ReactComponent };